import Dialog from '@zenbusiness/zui/Dialog';
import DialogTitle from '@zenbusiness/zui/DialogTitle';
import { styled } from '@zenbusiness/zui/styles';

const DialogStyle = ({ theme }) => ({
  zIndex: theme.zIndex.modal,
  padding: 0
});

const DialogTitleStyle = ({ theme, titleBackground }) => ({
  padding: '0px 5px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  height: 60,
  backgroundColor: titleBackground || theme.palette.background.grey.light
});

export const EmptyDivStyle = () => ({
  width: '40px'
});

export const DialogStyled = styled(Dialog)(DialogStyle);
export const DialogTitleStyled = styled(DialogTitle, {
  shouldForwardProp: (prop) => prop !== 'titleBackground'
})(DialogTitleStyle);
export const EmptyDivStyled = styled('div')(EmptyDivStyle);
